import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/require-default-props
function Loader({ className, label, style, fixed, centerInContainer, ...rest }) {
  const [calculatedTop, setCalculatedTop] = useState('50%');
  const loaderRef = useRef(null);

  const calculateTopPosition = () => {
    // Move the spinner to the correct position on the settings transaction dashboard
    const isMobile = window.innerWidth <= 991;
    const parentTxnsElement = loaderRef.current?.closest('.settings-transactions');
    const parentRatesElement = loaderRef.current?.closest('.return-rates');

    if (fixed) {
      setCalculatedTop(0);
    } else if (isMobile && parentTxnsElement && !parentRatesElement) {
      setCalculatedTop('90%');
    } else {
      setCalculatedTop('50%');
    }
  };

  useEffect(() => {
    calculateTopPosition();

    const handleResize = () => {
      calculateTopPosition();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fixed]);

  let positionClass = 'position-absolute';
  let positionStyles = {
    top: calculatedTop,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    height: 'auto',
    zIndex: 10,
    pointerEvents: 'none',
  };

  if (fixed) {
    positionClass = 'position-fixed';
    positionStyles = {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 10,
      pointerEvents: 'none',
    };
  } else if (centerInContainer) {
    positionClass = 'position-relative';
    positionStyles = {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
      pointerEvents: 'none',
    };
  }

  return (
    <div
      ref={loaderRef}
      className={`content-loading d-flex justify-content-center align-items-center ${positionClass}`}
      style={positionStyles}
    >
      <div className={`${className ? `${className} ` : ''}loader text-center`}>
        {!style && (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Spinner animation="border" role="status" variant="primary" {...rest}>
            <span className="visually-hidden">Loading....</span>
          </Spinner>
        )}
        {style === 'dots' && (
          <div className="dots">
            <div />
            <div />
            <div />
            <div />
          </div>
        )}
        {label && <p className="text-info text-sm mt-2">{label}</p>}
      </div>
    </div>
  );
}

Loader.propTypes = {
  /**
   * The optional label that is displayed underneath the spinner.
   */
  label: PropTypes.string,
  /**
   * The optional style.
   */
  style: PropTypes.string,
  /**
   * The optional classes.
   */
  className: PropTypes.string,
  /**
   * The optional position.
   */
  fixed: PropTypes.bool,
};

export default Loader;
